import { RuleObject } from 'antd/lib/form';
import React from 'react';

import TranslateText from 'components/hoc/TranslateText';

import { passwordRegExp } from 'enums/regExp';

export const passwordValidation = () => [
    () => ({
        validator(_rule: RuleObject, value: string) {
            if ((value.length > 128 || value.length < 8) && value)
                return Promise.reject(<TranslateText>NEVALIDNI_HESLO</TranslateText>);
            if (!value || passwordRegExp.test(value)) return Promise.resolve();
            return Promise.reject(<TranslateText>NEVALIDNI_HESLO</TranslateText>);
        }
    })
];

export default passwordValidation;
